export const TITLE = "Login";
export const INP_INSERT_USER = "Nutzername";
export const INP_INSERT_PASSWORD = "Passwort";
export const ERR_COMPLETE_FIELDS = "Bitte füllen Sie alle Felder aus.";
export const ERR_USER_PASS = "Nutzername oder Passwort unbekannt";
export const ERR_NETWORK_FAILED = "Network connection failed";
export const BTN_LOGIN = "ANMELDEN";